module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2015/june-a3eeeb0a91c81ba4a012016dce3b4ee4.png";